import React from 'react';
import { UtilityBanner } from '@grubhubprod/gh-cookbook-react';
import { sftpWarningCopy } from 'src/components/enterprise/features/Employee/components/Form/SftpWarningMessage/constants';
import { useSftpWarningMessage } from 'src/components/enterprise/features/Employee/components/Form/SftpWarningMessage/hooks/useSftpWarningMessage';

export const SftpWarningMessage: React.FC = () => {
  const { sftpEnabled } = useSftpWarningMessage();

  if (!sftpEnabled) {
    return null;
  }

  return (
    <UtilityBanner
      flavor="error"
      prominence="quiet"
      message={sftpWarningCopy}
    />
  );
};
